import React from "react";
import clsx from "clsx";

import { useHeaderVisibility } from "../../../lib/hook/NavigationHooks";

import { DISPLAY_NOTIFICATION } from "../../../Config";
import Navigation from "../../nav/Navigation/Navigation";
import MultiFleetBanner from "../MultiFleetBanner/MultiFleetBanner";
import * as ProgramSelectors from "../../../store/Program/Program.selector";
import MobileNav from "../../nav/MobileNav/MobileNav";
import { useSelector } from "../../../lib/hook/ReduxHooks";
import AnonymousModeBanner from "../AnonymousModeBanner/AnonymousModeBanner";

const Header: React.FC = () => {
	const { scopeProgramId, program } = useSelector((state) => {
		return {
			scopeProgramId: ProgramSelectors.getCurrentScopeProgramId(state),
			program: ProgramSelectors.getCurrentProgram(state),
		};
	});

	const headerVisible = useHeaderVisibility();

	return headerVisible ? (
		<div className={clsx("Header", { "-with-notif": DISPLAY_NOTIFICATION })}>
			<AnonymousModeBanner />
			{/* <MultiFleetBanner programId={scopeProgramId} program={program} /> */}
			<Navigation programId={scopeProgramId} />
			<MobileNav />
		</div>
	) : null;
};

export default React.memo(Header);
